var _rect, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFactsheet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.25,
    width: 27.5,
    height: 27.5,
    rx: 13.75,
    stroke: "url(#paint0_linear_237_12761)",
    strokeOpacity: 0.4,
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8975 11.9597C18.5621 12.0075 18.2202 11.9766 17.8988 11.8695C17.5775 11.7623 17.2855 11.5819 17.0459 11.3423C16.8064 11.1028 16.6259 10.8108 16.5187 10.4894C16.4116 10.168 16.3807 9.82614 16.4286 9.49078V7.02188H11.4908C11.1554 6.97403 10.8135 7.00491 10.4922 7.11206C10.1708 7.21921 9.87878 7.3997 9.63924 7.63924C9.3997 7.87878 9.21921 8.17079 9.11206 8.49215C9.00491 8.81352 8.97403 9.15542 9.02188 9.49078V19.3664C8.97403 19.7017 9.00491 20.0436 9.11206 20.365C9.21921 20.6864 9.3997 20.9784 9.63924 21.2179C9.87878 21.4574 10.1708 21.6379 10.4922 21.7451C10.8135 21.8522 11.1554 21.8831 11.4908 21.8353H18.8975C19.2328 21.8831 19.5747 21.8522 19.8961 21.7451C20.2175 21.6379 20.5095 21.4574 20.749 21.2179C20.9885 20.9784 21.169 20.6864 21.2762 20.365C21.3833 20.0436 21.4142 19.7017 21.3664 19.3664V11.9597H18.8975Z",
    fill: "#CABCFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.898 11.9597H21.3669L16.4291 7.02187V9.49076C16.3813 9.82612 16.4121 10.168 16.5193 10.4894C16.6264 10.8108 16.8069 11.1028 17.0465 11.3423C17.286 11.5818 17.578 11.7623 17.8994 11.8695C18.2207 11.9766 18.5626 12.0075 18.898 11.9597Z",
    fill: "url(#paint1_linear_237_12761)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5089 18.0636C14.4278 18.0637 14.3476 18.0477 14.2727 18.0166C14.1978 17.9856 14.1299 17.94 14.0727 17.8825L12.7008 16.5107C12.5918 16.3937 12.5324 16.2389 12.5353 16.079C12.5381 15.9191 12.6029 15.7665 12.7159 15.6534C12.829 15.5404 12.9816 15.4756 13.1415 15.4728C13.3014 15.4699 13.4562 15.5293 13.5732 15.6383L14.5089 16.5732L16.8132 14.2689C16.9296 14.1565 17.0856 14.0944 17.2474 14.0959C17.4092 14.0973 17.564 14.1623 17.6784 14.2768C17.7928 14.3913 17.8576 14.5462 17.859 14.708C17.8603 14.8698 17.798 15.0257 17.6855 15.1421L14.9475 17.885C14.8898 17.9423 14.8214 17.9876 14.7461 18.0182C14.6708 18.0489 14.5902 18.0643 14.5089 18.0636Z",
    fill: "url(#paint2_linear_237_12761)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_237_12761",
    x1: 14.5,
    y1: 0,
    x2: 14.5,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAC2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9383F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_237_12761",
    x1: 21.3669,
    y1: 9.5017,
    x2: 16.4072,
    y2: 9.5017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A631FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#896DFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_237_12761",
    x1: 17.859,
    y1: 16.0797,
    x2: 12.5352,
    y2: 16.0797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A631FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#896DFA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFactsheet);
export default __webpack_public_path__ + "static/media/factsheet.4bce125d300f5c40223d6a620433de53.svg";
export { ForwardRef as ReactComponent };